import React from 'react'
import { Grid, Popup, Icon } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';
import Labels from './../../../../common/Labels'
import ColorPalette from './../../../../common/ColorPalette'
import EditText from '../../../../common/EditText';
import MultiLineEditText from '../../../../common/MultiLineEditText';
import SingleLineEditText from '../../../../common/SingleLineEditText';


@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext('Role Details Card')
    }
})

class CommunityRoleResourcePaneForm extends React.Component {
    saveData = (data) => {
        this.props.selectedPracticeFlowCommunity.description = data.text;
        dispatch.createPack.editCommunityAsync(this.props.selectedPracticeFlowCommunity)
    }

    saveName = (data) => {
        this.props.selectedPracticeFlowCommunity.name = data.text;
        dispatch.createPack.editCommunityAsync(this.props.selectedPracticeFlowCommunity)
    }

    render() {
        const styles = {
            color: {
                width: '20px',
                height: '16px',
                borderRadius: '2px',
                background: this.props.selectedPracticeFlowCommunity.tagColor,
            },
            swatch: {
                padding: '1px',
                background: '#fff',
                borderRadius: '1px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                display: 'inline-block',
                cursor: 'pointer',
                margin: '0 0 20px 5px'
            }
        }

        const description = () => {
            if (this.props.status === 0) {
                return (
                    <MultiLineEditText
                        name="Description"
                        text={this.props.selectedPracticeFlowCommunity.description}
                        type="textarea"
                        onSaveClick={this.saveData}
                        htmlView={true} />

                )
            } else {
                return (
                    <Labels
                        name="Description"
                        text={this.props.selectedPracticeFlowCommunity.description}
                        htmlView={true} />
                )
            }
        }

        return (
            <Form noValidate
                className="formcyForm"
                ref={ref => this.form = ref}
                onValidSubmit={this.props.onSubmit}>
                <Grid >
                    <Grid.Row>
                        <Grid.Column >

                            {this.props.status !== 0 ?
                                <Labels
                                    name="Name"
                                    text={this.props.selectedPracticeFlowCommunity.name}
                                /> :
                                <SingleLineEditText
                                    name="Name"
                                    text={this.props.selectedPracticeFlowCommunity.name}
                                    type="text"
                                    onSaveClick={this.saveName}
                                />
                            }

                            <div>
                                {description()}
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    {this.props.selectedPracticeFlowCommunity &&
                        this.props.selectedPracticeFlowCommunity.parentCommunity &&
                        this.props.selectedPracticeLibrary.status === 0 ?
                        <Grid.Row style={{ margin: "10px 0" }}>
                            Tags : <Popup
                                basic
                                flowing hoverable
                                trigger={<div style={styles.swatch} >
                                    <div style={styles.color} />
                                </div>}
                                content={<ColorPalette selectedPracticeLibrary={this.props.selectedPracticeLibrary} selectedPracticeFlowCommunity={this.props.selectedPracticeFlowCommunity} />}
                                position='top right'
                                className="colorPopUp"
                            />
                        </Grid.Row>
                        : ''}

                </Grid>
            </Form>
        )
    }
}

export default CommunityRoleResourcePaneForm